/*========================================================================
* $Id: queryinfo.js 97320 2017-04-07 11:14:01Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "client/template",
    "component!base",
    "!!raw-loader!../mustache/template.mustache",
    "backbone",
    "component!suggest",
    "component!inputdate",
    "component!searchform",
    "jquery",
    "underscore",
    "i18n/i18n",
    "utils/jsonpath",
    "utils/dom",
    "utils/clone",
    "model/tree"
  ], function(
    Template,
    Base,
    DEFAULT_TEMPLATE,
    Backbone,
    SuggestTemplate,
    Inputdate,
    SearchForm,
    $,
    _,
    i18n,
    JSONPath,
    dom,
    deepClone,
    TreeModel
  ) {

    var AND_EXPR = "AND";
    var OR_EXPR = "OR";

    var QueryInfo;

    function getDefaultModel(conjunctionType) {
      if (conjunctionType === "AND") {
        return { "or": [{ "and": [] }] };
      }
      return { "or": [] };
    }

    function simplifyExpressions (model) {
      /**
      * Removes objects with an empty label by given model/expression
      * Example:
      * Input:
      *  {
      *   "or": [{ "and": [
      *       { label: '', unparsed: '' },
      *       { label: 'extension', unparsed: 'pdf'}
      *     ]
      *   }]
      *  };
      * 
      * Output:
      *  {
      *   "or": [{ "and": [
      *       { label: 'extension', unparsed: 'pdf'}
      *     ]
      *   }]
      *  };
      */
      if (model.or) {
        for (var i=0; i<model.or.length; i++) {
          if (model.or[i].and) {
            for (var j=0; j<model.or[i].and.length; j++) {
              var item = model.or[i].and[j];
              if (!item.label) {
                var model = JSON.parse(JSON.stringify(model));
                model.or[i].and.splice(j, 1);
                if (model.or[i].and.length === 0) {
                  model.or.splice(i, 1);
                  break;
                }
              }
            }
          }
        }
      }
      return model;
    };

    var QueryExprView = Backbone.View.extend({

      events: {
        "click .add-query-expr-field": "addQueryExpr",
        "click .remove-query-expr": "removeQueryExpr",
        "click .duplicate-query-expr-group": "duplicateExprGroup",
      },

      initialize: function(options) {
        Backbone.View.prototype.initialize.apply(this, arguments);
        this.queryExpr = options.queryExpr;
        this.path = options.path;
        this.options = options;  

        var relativePath = this.path;
        if (options.model.path) {
          if (this.path.indexOf(options.model.path) == 0) {
            relativePath = this.path.substr(this.model.path.length + 1);
          }
        }
        this.parsedPath =  JSONPath.parsePath(relativePath.replaceAll(/\.(\d+)($|\.)/g, "[$1]$2"));
      },

      getActionLabel: function (value, defaultValue) {
        return i18n(this.options[value] || defaultValue);
      },

      getParsedPath: function () {
        return this.parsedPath && this.parsedPath.map(String);
      },

      getClonedModelByPath: function (path) {
        return _.clone(this.model.get(path));
      },

      addQueryExpr: function () {
        var parsedParsePath = this.getParsedPath();
        var newConstraint =  this.getClonedModelByPath(parsedParsePath);
        
        if (!newConstraint.and) {
          return;
        }
        newConstraint.and.push({label: '', unparsed: ''});

        this.model.set(newConstraint, {path: parsedParsePath});
      },

      removeQueryExpr: function() {
        var path = this.parsedPath;
        var type = this.options["default-conjunction"] || AND_EXPR;
        var atts = getDefaultModel(type);

        if (path === null || path === undefined) {
          this.options.model.clear( {silent: false} );
          return;
        }

        var model = this.options.model.get();
        if (!model) {
          atts = {};
          this.options.model.clear( {silent: false} );
          this.options.model.set(atts);
          return;
        }

        var atts = JSON.parse(JSON.stringify(model));
        for (var i = path.length - 1; i > 0; --i)  {
            var index = path[i];
            var parentPath = _.first(path, i);
            var parent = JSONPath.get(atts, parentPath);
            JSONPath.unset(parent, [index]);
            if (!_.isEmpty(parent)) {
              break;
            }            
        }

        if (atts && _.isEmpty(atts.or) && _.isEmpty(atts.and) ) {
          var type = this.options["default-conjunction"] || AND_EXPR;
          var atts = getDefaultModel(type);
          this.options.model.clear( {silent: false} );
          this.options.model.set(atts);
          return;
        }

        this.options.model.set(atts);
        return;
      },

      duplicateExprGroup: function () {
        var parsedParsePath = this.getParsedPath();
        var constraintDoBeDuplicated =  this.getClonedModelByPath(parsedParsePath);
      
        var atts = deepClone(this.model.get());
        
        if (!atts || !atts.or) {
          return;
        }

        atts.or.push(constraintDoBeDuplicated);

        this.options.model.clear( {silent: false} );
        this.options.model.set(atts);
      },

      createFromQueryExpr: function(queryExpr, options) {
        if (queryExpr.and || queryExpr.or) {
          return new ContainerQueryExprView(_.extend({}, options, {el: null, queryExpr: queryExpr, path: options.path}));
        } else {
          return new LeafQueryExprView(_.extend({}, options, {el: null, queryExpr: queryExpr, path: options.path}));
        }
      }
    });

    var AddQueryExprView = Backbone.View.extend({
      events: {
        "click .add-query-expr": "submit",
        "click .add-query-expr-group": "addGroup",
        "click .close-query-expr": "removeQueryExprTemplate"
      },

      initialize: function(options) {
        Backbone.View.prototype.initialize.apply(this, arguments);
        this.selectOptions = this.options.selectOptionProperties || {};
        this.isAdding = false;
        this.addNewExprView;
      },

      getActionLabel: function (value, defaultValue) {
        return i18n(this.options[value] || defaultValue);
      },

      removeQueryExprTemplate: function (event) {
        var model = this.options.model.get();
        this.options.model.set(model);
        this.el.remove();
      },

      submit: function () {
        var expressions = this.model.get();
        this.options.originalInputModel.clear({silent: true});

        expressions = simplifyExpressions(expressions);
        this.options.originalInputModel.set(expressions);
      },

      addGroup: function() {
        if (_.isEmpty(this.selectOptions)) {
          return;
        }

        var label = "";
        var value = "";

        var newAndElement = {
          "label": label,
          "unparsed": value
        };

        var selectedOption = this.selectOptions[label];
        if (selectedOption.type == "inputdate") {
          delete newAndElement.label;
          var picker = this.picker.data("daterangepicker");
          var start = picker.startDate.format("YYYY-MM-DD");
          var end = picker.endDate.format("YYYY-MM-DD");
          newAndElement.description = i18n("daterangepicker_from") + " " + start + " " + i18n("daterangepicker_to") + " " + end;
          newAndElement.unparsed = label + ":["+ start +" TO "+ end +"]";
        }

        var model = this.options.model.get();

        var selector = this.options["default-conjunction"] || AND_EXPR;
        var defaultQueryTree = getDefaultModel(selector);
        var querytree;

        if (!model || _.isEqual(model, getDefaultModel("AND"))) {
          // create new tree
          querytree = this.prepareQueryTree(defaultQueryTree, selector, newAndElement);
        } else if (model.or) {
          // add new group
          querytree = JSON.parse(JSON.stringify(model));
          newAndElement = {"and": [newAndElement]};
          querytree = this.prepareQueryTree(querytree, "OR", newAndElement);
        }

        if (querytree && querytree.and) {
          querytree = { "or": querytree };
        } else if (querytree && !querytree.or) {
          querytree = { "or": [{ "and": [querytree]}]}
        }

        var querytree = deepClone(querytree);

        this.options.model.clear({silent: true});
        this.options.model.set(querytree);
      },

      prepareQueryTree: function (querytree, selector, newAndElement) {
        if (querytree.or && _.isEmpty(querytree.or) && selector === "AND") {
          querytree = {"or": [{"and": [newAndElement]}]};
        }
        else if (querytree.or) {
          var index = querytree.or.length - 1;
          var lastOR = _.last(querytree.or);
          if (selector == "AND") {
            if (lastOR.and) {
              lastOR.and.push(newAndElement);
            }
            else {
              querytree.or[index] = {"and":  [lastOR, newAndElement]};
            }
          }
          else if (selector == "OR") {
            querytree.or.push(newAndElement);
          }
        }
        else if (querytree.and) {
          if (selector == "AND") {
            querytree.and.push(newAndElement);
          }
          else if (selector == "OR") {
            querytree = {"or": [querytree, newAndElement]};
          }
        }
        else {
          if (selector == "AND") {
            if (_.isEmpty(querytree)) {
              querytree = newAndElement;
            } else {
              querytree = {"and": [querytree, newAndElement]};
            }
          }
          else if (selector == "OR") {
            if (_.isEmpty(querytree)) {
              querytree = newAndElement;
            } else {
              querytree = {"or": [querytree, newAndElement]};
            }
          }
        }
        return querytree;
      },

      render: function() {
        this.cleanUp();

        if (this.options.editable) {
          var addGroupLabel = this.getActionLabel("add-group-label", "add_group_label");
          var addGroupLabelTooltip = this.getActionLabel("add-group-label-tooltip", "add_group_label");
          this.$el.append("<button class='add-query-expr-group icon-add' title='" + addGroupLabelTooltip + "'>"+ addGroupLabel +"</button>");

          var submitLabel = this.getActionLabel("submit-label", "submit");
          var submitLabelTooltip = this.getActionLabel("submit-label-tooltip", "submit");
          this.$el.append("<button class='add-query-expr icon-plus' title='" + submitLabelTooltip + "'>"+ submitLabel +"</button>");
        }

        return this.el;
      },

      cleanUp: function() {
        this.el.innerHTML = "";
        this.el.className="add-expressions-container";
        this.$el.empty();
      }
    });

    var SubmitView = Backbone.View.extend({

      initialize: function(options) {
        this.parentThis = options.that;
      },

      submit: function (event, undefined, submittedValue) {
        var queryExpr = $(event.target).data("queryexpr");
        var parsedParsePath = this.parentThis.parsedPath && this.parentThis.parsedPath.map(String);
        var newConstraint =  _.clone(this.parentThis.options.model.get(parsedParsePath));
        if (submittedValue) {
          newConstraint.unparsed = submittedValue;
          if (newConstraint.not) {
            delete newConstraint.unparsed;
            newConstraint.not.unparsed = submittedValue;
          }
          this.parentThis.options.model.set(newConstraint, {path: parsedParsePath});

        } else if (queryExpr) {
          var label = newConstraint.label;
          newConstraint.description = queryExpr.description;
          if (queryExpr.and) {
            var from = new Date(queryExpr.and[0].num).toISOString().slice(0, 10);
            var to = new Date(queryExpr.and[1].num).toISOString().slice(0, 10);
            
            if (!label) {
              label = newConstraint.unparsed.split(":[")[0];
            }

            var unparsedValue = label + ':[' + from + ' TO ' + to + ']';
            newConstraint.unparsed = unparsedValue;
            if (newConstraint.not) {
              delete newConstraint.unparsed;
              newConstraint.not.unparsed = unparsedValue;
            }
            delete newConstraint.label;
            this.parentThis.options.model.set(newConstraint, {path: parsedParsePath});
          }
        }
      }

    });

    var ContainerQueryExprView = QueryExprView.extend({

      tagName: "div",
      className: "constraint-container",

      initialize: function(options) {
        QueryExprView.prototype.initialize.apply(this, arguments);

        this.options = options;

        if (this.queryExpr.and) {
          this.type = AND_EXPR;
          this.elements = this.queryExpr.and;
          this.path = (options.path || []).concat(options.path ? [".and"] : ["and"]);
        } else if (this.queryExpr.or) {
          this.type = OR_EXPR;
          this.elements = this.queryExpr.or;
          this.path = (options.path || []).concat(options.path ? [".or"] : ["or"]);
        }
      },

      render: function(options) {
        var that = this;
        this.cleanUp();

        if (this.options.class) $(this.el).addClass(this.options.class);

        _.each(this.elements, function(queryExpr, index) {
          var options = _.extend(that.options, { el: null, path: that.path.concat(["." + index]), queryExpr: queryExpr });
          if (queryExpr.and) options.class = "children-container";
          var element = QueryExprView.prototype.createFromQueryExpr(queryExpr, options).render({renderActions: true});
          that.el.appendChild(element);
        });

        if (this.elements && this.elements.length && options && options.renderActions) {
          var removeGroupLabel = that.getActionLabel("remove-group-label", "editor_remove_all_label");
          var removeGroupLabelTooltip = that.getActionLabel("remove-group-label-tooltip", "editor_remove_all_label");
          that.$el.append("<button class='remove-query-expr icon-remove' title='" + removeGroupLabelTooltip + "'>" + removeGroupLabel + "</button>");

          var addExpressionlabel = that.getActionLabel("add-expression-label", "add_expression_label");
          var addExpressionlabelTooltip = that.getActionLabel("add-expression-label-tooltip", "add_expression_label");
          that.$el.append("<button class='add-query-expr-field icon-add' title='" + addExpressionlabelTooltip + "'>"+ addExpressionlabel +"</button>");

          var duplicateGroupLabel = that.getActionLabel("duplicate-group-label", "duplicate_group_label");
          var duplicateGroupLabelTooltip = that.getActionLabel("duplicate-group-label-tooltip", "duplicate_group_label");
          that.$el.append("<button class='duplicate-query-expr-group icon-duplicate' title='" + duplicateGroupLabelTooltip + "'>"+ duplicateGroupLabel +"</button>");
        }

        return this.el;
      },

      cleanUp: function() {
        this.el.innerHTML = "";
        this.$el.empty();
      }

    });

    var LeafQueryExprView = QueryExprView.extend({

      tagName: "div",
      className: "constraints constraint metadata",

      initialize: function(options) {
        QueryExprView.prototype.initialize.apply(this, arguments);
        this.element = options.queryExpr;
        this.path = options.path;
      },

      getConjunctionType: function() {
        var firstPart = _.last(this.parsedPath, 2);
        if (firstPart[0] == "and") {
          var secondPart = _.last(this.parsedPath, 4);
          if (firstPart[1] == "0" && secondPart[0] == "or") {
            if (secondPart[1] == "0") {
              return "AND";
            }
            else {
              return "OR"
            }
          }
          return "AND"
        }
        else if (firstPart[0] == "or" ) {
          if (firstPart[1] == "0") {
            return "AND"
          }
          return "OR";
        }
        return "";
      },

      isFirstElement: function() {
        if (!this.parsedPath) return true;
        var firstPart = _.last(this.parsedPath, 2);
        if (firstPart[0] == "and" && firstPart[1] == "0") {
          firstPart = _.last(this.parsedPath, 4);
        }
        return firstPart[0] == "or"  && firstPart[1] == "0" ||  firstPart[0] == "and"  && firstPart[1] == "0";;
      },

      remove: function (options) {
      },

      conjunctionTypeSelectionChanged: function(event) {
        var newValue =  this.conjSelectorEl.value;
        if (newValue == "OR") {
          var firstPart = _.last(this.parsedPath, 4);
          var parentPath = _.first(this.parsedPath, this.parsedPath.length -1);
          var parent =  this.options.model.get(parentPath);         
          var andIndex = parseInt(firstPart[3]);
          var newOrElement = {"and":_.last(parent, parent.length-andIndex)};
          var existingOrPath = _.first(this.parsedPath, this.parsedPath.length -3);
          var newOrs =  _.clone(this.options.model.get(existingOrPath));
          if (newOrs) {
             newOrs.splice(parseInt(firstPart[1])+1, 0, newOrElement);
          }
          var ands = newOrs[parseInt(firstPart[1])][firstPart[2]];   
          if (ands) {  
             newOrs[parseInt(firstPart[1])][firstPart[2]] = ands.slice(0, andIndex);
          }          
        }
        else if (newValue == "AND") {
          var firstPart = _.last(this.parsedPath, 2);
          if (firstPart[0] == "and") {
            firstPart = _.last(this.parsedPath, 4);

            var existingOrPath = _.first(this.parsedPath, this.parsedPath.length -3);
            var newOrs =  _.clone(this.options.model.get(existingOrPath));
            var orIndex = parseInt(firstPart[1]);
            var prevOrIndex = orIndex - 1;
            var newAnds = newOrs[orIndex]["and"];
          } 
          else if (firstPart[0] == "or") {
            var existingOrPath = _.first(this.parsedPath, this.parsedPath.length -1);
            var newOrs =  _.clone(this.options.model.get(existingOrPath));
            var orIndex = parseInt(firstPart[1]);
            var prevOrIndex = orIndex - 1;
            var newAnds = [newOrs[orIndex]];
          } else {
            return;
          }
          
           newOrs.splice(orIndex, 1);
           newOrs[prevOrIndex] = _.clone(newOrs[prevOrIndex]);
           if (newOrs[prevOrIndex]["and"]) {
            newOrs[prevOrIndex]["and"] = newOrs[prevOrIndex]["and"].concat(newAnds);
           }
           else {
             newOrs[prevOrIndex] = {"and": [newOrs[prevOrIndex]].concat(newAnds)};
           }
        } else {
          return;
        }

        this.options.model.set(newOrs, {path: existingOrPath}); 
      },

      labelSelectionChanged: function (event) {
        var newProperty = this.labelEl.value;
        var newItem =  _.clone(this.options.model.get(this.parsedPath));
        if (newItem.not) {
          newItem.not[0].label = newProperty;
          newItem.label = newProperty;
        } else {
          newItem.label = newProperty;
        }
        
        this.options.model.set(newItem, {path: this.parsedPath && this.parsedPath.map(String)}); 
      },

      labelValueChanged: function (event) {
        var label = event.target.value;
        var item =  _.clone(this.options.model.get(this.parsedPath));
        item.unparsed = label;
        if (!_.isEmpty(item.not)) {
          item.not[0].unparsed = label;
          delete item.unparsed;
        }
        this.options.model.set(item, {path: this.parsedPath && this.parsedPath.map(String)}); 
      },

      logicalOperatorSelectionChanged: function () {
        var newValue =  this.logicalOperator.value;
        var path = this.parsedPath && this.parsedPath.map(String);
        var item =  _.clone(this.options.model.get(this.parsedPath));
        if (newValue === "NOT") {
          var originalUnparsed = item.unparsed;
          delete item.unparsed;
          item["not"] = [{ 
            "unparsed": originalUnparsed,
            "label": item.label
          }];
        } else {
          item["unparsed"] = item.not && item.not[0] && item.not[0].unparsed;
          delete item.not;
        }
        
        if (!path) {
          this.options.model.clear();
          this.options.model.set(item, {path: path});
          return;

        } else {

          var parentPath = _.first(this.parsedPath, this.parsedPath.length -1);
          var parentModel = _.clone(this.options.model.get(parentPath));

          var lastPath = _.last(this.parsedPath);
          parentModel[lastPath] = item;

          this.options.model.set(parentModel, {path: parentPath});
        }

      },

      createSelectElement: function (name, callback) {
        var element = document.createElement("select");
        element.setAttribute("name", name);
        if (callback) {
          element.addEventListener("change", callback);
        }
        return element;
      },

      logicalOperatorValue: function () {
        if (this.originalElement.not) { return "NOT" };
        return "";
      },

      getLabelValue: function (element) {
        var label = element.label;
        if (!_.isUndefined(label)){
          return label;
        }
        return element.unparsed.split(":[")[0]; // it is a date if no label is set
      },

      render: function() {
        var that = this;

        this.originalElement = _.clone(this.element);

        var label = this.getLabelValue(this.element);

        if (this.options.editable === "true") {
          // editable searchform

          if (!this.isFirstElement()) {
            this.conjSelectorEl = this.createSelectElement("conjunctionselector", _.bind(this.conjunctionTypeSelectionChanged, this));
            $(this.conjSelectorEl).append("<option value='AND'>"+ i18n("client_label_and") +"</option><option value='OR'>"+ i18n("client_label_or") +"</option>");
  
            this.$el.append(this.conjSelectorEl);
            var conjunctionType  = this.getConjunctionType();
            if (conjunctionType) {
              this.conjSelectorEl.value = conjunctionType;
            }
          }
  
          // HTML select 
          this.labelEl = this.createSelectElement("", _.bind(this.labelSelectionChanged, this));

          var selectedOption = _.find(this.options.selectOptionProperties, function (item, key) {
            return label === key;
          });
  
          var selectOptions = this.options.selectOptionProperties || {};
          
          var options_str = "";
          _.each(selectOptions, function(key, value) {
            var defaultSelection = "";
            if (value === label) {
              defaultSelection = "SELECTED";
            }
            options_str += '<option ' + defaultSelection + ' value="' + value + '">' + key.label + '</option>';
          });
  
          if (!selectedOption) {
            // Add default property if it is not available in the given property list
            options_str += '<option SELECTED value="' + label + '">' + label + '</option>';
            selectedOption = { label: label, type: "suggest"};
          }
  
          this.labelEl.innerHTML = options_str;
          this.$el.append(this.labelEl); 


          // logical operators
          this.logicalOperator = this.createSelectElement("logicalOperator", _.bind(this.logicalOperatorSelectionChanged, this));
          $(this.logicalOperator).append("<option value=''></option><option value='NOT'>"+ i18n("NOT") +"</option>");
          this.$el.append(this.logicalOperator);
          var logicalOperatorValue  = this.logicalOperatorValue();
          if (logicalOperatorValue) {
            this.logicalOperator.value = logicalOperatorValue;
          }

          this.createInputView(selectedOption.type, function() {
            // append a remove button for each input field
            var removeLabel = that.getActionLabel("remove-expression-label", "editor_remove_label");
            var removeLabelTooltip = that.getActionLabel("remove-expression-label-tooltip", "editor_remove_label");
            that.$el.append("<button class='icon-remove remove-query-expr' title='" + removeLabelTooltip + "'>" + removeLabel + "</button>");
          });

        } else {
          // bubble text

          if (!this.isFirstElement()) {
            var relationElement = document.createElement("div");
            relationElement.className = "constraint-type relation";

            var conjunctionType  = this.getConjunctionType();
            if (conjunctionType === "AND") {
              relationElement.innerHTML = i18n("client_label_and");
              relationElement.className += " and-relation";
            } else {
              relationElement.innerHTML = i18n("client_label_or");
              relationElement.className += " or-relation";
            }
            this.$el.append(relationElement);
          };

          var key = this.element.label;
          var value = this.element.unparsed;
          this.labelEl = document.createElement('button');
          this.labelEl.className = "icon-remove remove-query-expr";
          this.labelEl.innerHTML = "<strong>"+ key +"</strong>:"+ value;

          this.$el.append(this.labelEl); 
        }

        return this.el;
      },

      _getUserInputOptions: function (Component) {
        var options = {};

        options.appendTo = this.el;
        options = _.extend({}, options, new dom.AttributeModel(this.el, "data-user-input-").get());
        _.each(this.options, function (value, key) {
          if (/userInput.*/.test(key)) {
            options[dom.AttributeModel.camelCaseToSeparated(key).substring(11)] = value;
          }
        });
        delete options.template;
        delete options[""];
  
        if (Component && Component.prototype.schema) {
          options = Component.prototype.schema.parseAttributes(options);
        }
  
        options.grouped = false;
  
        options = _.extend({
            model: this.model,
            placeholder: "search",
            application: this.options.application,
            channel: this.options.application.models.search.wiring.channel,
            property: this.options.facetName,
            sources: ["DOCUMENT_PROPERTY"],
            termConstraintLabel: this.options.termConstraintLabel,
            excludedFilterID: this.filterID,
            showOnfocus: true,
            getAndSetParentQueryExpr: false,
            addQueryConstraints: false,
            useConstraintsOnly: true,
          }, options);
       
        return options;
      },

      getSuggestProperty: function (label) {
        return this.options.selectOptionProperties && 
               this.options.selectOptionProperties[label] &&
               this.options.selectOptionProperties[label].suggestProperty || label;
      },

      onAutocompleteselect: function (event, data, traceContext, options) {
        var label = event.target.value;
        var item =  _.clone(this.options.model.get(this.parsedPath));
        if (item.not) {
          item.not[0].unparsed = label;
          delete item.unparsed;
        } else {
          item.unparsed = label;
        }
        this.options.model.set(item, {path: this.parsedPath && this.parsedPath.map(String)}); 
      },

      createInputView: function (userInputTemplate, callback) {
        var that = this;
        var property = that.element.label,
            suggestProperty = this.getSuggestProperty(that.element.label);
        
        var elementValue = that.element.description || that.element.unparsed || that.element.term || "";
        if (that.element.not && !that.element.description) {
          elementValue = that.element.not[0].unparsed;
        }

        var parentView = new SubmitView({ that: that });

        if (userInputTemplate == "suggest") {
          var options = that._getUserInputOptions(SuggestTemplate);
          options = _.extend({},
            options,
            { 
              property: suggestProperty,
              parentView: parentView,
            }
          );
          that.userInputView = new SuggestTemplate.View(options);

        } else if (userInputTemplate == "inputdate") {
          var options = that._getUserInputOptions(Inputdate);
          options = _.extend({},
            options,
            { 
              property: suggestProperty,
              isrange: "true",
              format: "YYYY-MM-DD",
              parentView: parentView,
              preserveOriginalOptionsParentView: true,
              showFromAndToActions: true
            }
          );
          that.userInputView = new Inputdate.View(options);

        } else {
          return; 
        }

        that.userInputView.render();
        that.userInputView.el.value = elementValue;
        that.userInputView.el.addEventListener("change", _.bind(that.labelValueChanged, that));
        $(that.userInputView.el).on("autocompleteselect", _.bind(this.onAutocompleteselect, this));

        that.el.appendChild(that.userInputView.el);
        callback();
      }
    });

    QueryInfo = Template.extend({

      hasContent: function () {
        return true;
      },

      getDefaultTemplate: function () {
        return DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;
      },

      model: function(options) {

        var inputModel = options.model;

        var inputPath = this.attributeModel.get("input-path") || "user.constraints";
        inputModel = inputModel.input.submodel(inputPath);
        return inputModel;
      }

    });

    QueryInfo.View = Base.extend({

      updateInputModel: function(originalInputModel) {
        var expressions = this.options.model.get();
        var originalModel = originalInputModel.get();

        var isEqual = _.isEqual(expressions, originalModel);
        if (!isEqual && !_.isUndefined(expressions)) {

          var confirmQueryInfoUpdateFunctionResponse = true;
          var confirmQueryInfoUpdateFunction = new Function("application", "view", "return application.confirmQueryInfoUpdate;" );
          if (confirmQueryInfoUpdateFunction && confirmQueryInfoUpdateFunction.call) {
            confirmQueryInfoUpdateFunctionResponse = confirmQueryInfoUpdateFunction.call(this.options.model, this.options.application, this);
          }

          if (confirmQueryInfoUpdateFunctionResponse && !confirmQueryInfoUpdateFunctionResponse.call()) {
            // to not continue and leave the expressions open
            return;
          }
        }

       originalModel = simplifyExpressions(originalModel);

        this.options.model.clear({silent:true});
        this.options.model.set(deepClone(originalModel));
      },

      propagateToParent: function (model) {
        var expressions = this.options.model.get(); // advanced search expressions
        if (!expressions) {
          expressions = getDefaultModel("AND");
          expressions.or[0].and[0] = { label: '', unparsed: ''};
        }
        this.options.originalInputModel.set(expressions, {silent: true}); // parent search
      },

      setModel: function(model) {
        var that = this;
        this.options.selectOptionProperties = {};
        
        if (this.options.editable) {
          this.options.originalInputModel = model;
          
          this.options.originalInputModel.on("change", _.bind(this.updateInputModel, this));

          var inputPath =this.options["input-path"];
          if (inputPath) {
            var treeModel = new TreeModel(deepClone(this.options.model.treeModel.get()));
            model = treeModel.submodel(inputPath);
          }
          else {
            model = new TreeModel(deepClone(model.get()));
            model.path = "";          
          }

          var getQueryinfoSelectOptionPropertiesName = "application.getQueryinfoSelectOptionProperties";
          var queryinfoSelectOptionPropertiesFunction = new Function("application", "view", "return " + getQueryinfoSelectOptionPropertiesName + ";" );
          var getQueryinfoSelectOptionProperties = queryinfoSelectOptionPropertiesFunction.call(this.options.model, this.options.application, this);
          this.options.selectOptionProperties = getQueryinfoSelectOptionProperties
                                                && getQueryinfoSelectOptionProperties.call
                                                && getQueryinfoSelectOptionProperties.call()
                                                || {};
        }

        // TODO if this.orgiinalInputModel changes then do what?
        // model has input, output
        this.options.model = model;
        Base.prototype.setModel.apply(this, arguments);
        
        this.listenTo(model, "change", function() {
          
          if (that.options["include-on-change-main-app-search-input"]) {
            that.propagateToParent(this);
          }

          that.render();
        });

        // render Add Expression at the beginning
        this.render();
      },

      defaultOptions: {
        titleTagName: "h2",
        titleClassName: "title",
        removeIcon: "false",
        removeAllLabel: i18n("editor_remove_all_label"),
        removeLabel: i18n("editor_remove_label"),
        addExpressionLabel: i18n("add_expression_label"),
        editable: false
      },

      schema: new Template.Schema({
        attributes: {
          title: {
            type: "string",
            title: "editor_title_label"
          },
          titleTagName: {
            type: "string",
            title: "editor_title_tag_label"
          },
          titleClassName: {
            type: "string",
            title: "editor_title_class_label"
          },
          removeIcon: {
            type: "boolean",
            "default": false
          },
          removeLabel: {
            type: "string",
            title: "editor_remove_label"
          },
          removeAllLabel: {
            type: "string",
            title: "editor_remove_all_label"
          },
          addExpressionLabel: {
            type: "string",
            visible: false
          },
          editable: {
            type: "boolean",
            visible: false
          },
          includeOnChangeMainAppSearchInput: {
            type: "boolean",
            visible: false
          },
          submitExpressionLabel: {
            type: "string",
            visible: false
          },
          closeLabel: {
            type: "string",
            visible: false
          }
        }
      }),

      modelContainsElements: function (model) {
        if (!model) { return false };

        var defaultConjunction = this.options["default-conjunction"] || AND_EXPR;
        if (defaultConjunction === "AND") {
          if (model.id) { return true; }
          if (model.or || model.and) {

            var unparsedOr = model.or && model.or[0] && model.or[0].unparsed;
            var andOr = model.or && model.or[0] && model.or[0].and;
            var unparsedOrAnd = model.or && model.or.and &&  model.or.and[0] && model.or.and[0].unparsed;

            if (
              !_.isEmpty(model.and) ||
              !_.isEmpty(model.or) &&
              ((!_.isEmpty(unparsedOr) || !_.isEmpty(andOr)) || !_.isEmpty(unparsedOrAnd))
            ) {
              return true;
            } 

            return false
          } else {
            return false;
          }
        } else {
          return model.or && model.or.length || model.and && model.and.length
        }
      },

      render: function (options) {

        if (this.queryExprView) {
          // do not remove existing innerHMTL (e.g. tooltip, custom additional html)
          this.$el.find(".title").remove();
        }

        if (!this.containerEl) {
          this.containerEl = document.createElement("div");
          this.containerEl.className = "parent-constraint-container";

          this.$el.empty();
          var addQueryExprView = new AddQueryExprView(_.extend({}, this.options, {el: null, path: this.options.path}));
          this.$el.append(addQueryExprView.render());
        }
        
        var model = this.model.get();

        var isModelReady = this.modelContainsElements(model);

        if (isModelReady) {
          var viewOptions = _.extend({}, this.options, {model: this.model, path: this.model.path, el: null});        

          this.queryExprView && this.queryExprView.remove();

          this.queryExprView = QueryExprView.prototype.createFromQueryExpr(model, viewOptions);
          
          if (this.queryExprView.elements && this.queryExprView.elements.length || this.queryExprView.element ) {
            this.$el.removeClass("hide-element");
            this.titleEl = this.appendChild(this.make(this.options.titleTagName, { id: this.cid + "_title",  "class": this.options.titleClassName || "" }, i18n(this.options.title)), true);
            this.el.prepend(this.titleEl);
          }

          var newEl = this.queryExprView.render();
          if (this.queryExprViewEl && this.queryExprViewEl.parentElement) {
            this.queryExprViewEl.parentElement.replaceChild(newEl, this.queryExprViewEl);
          }
          else {
            this.containerEl.appendChild(newEl);
          }
          this.queryExprViewEl = newEl;
         
          if (!this.containerEl.parentElement) {
            this.el.appendChild(this.containerEl);
          } 
        } else {
          this.containerEl.remove();
          this.queryExprView && this.queryExprView.remove();
        }
      }

    });

    return QueryInfo;
});
